import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { NotificationService } from "../../common/component/notification/notification.service";
import { Lookup } from '../model/lookup';

@Injectable()
export class LookupService {

    constructor(private http: HttpClient, private notificationService: NotificationService) {

    }

    getLookupValues(lookupType: string): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(environment.apiBaseUrl + `lookup?lookupType=${lookupType}`)
            .pipe(catchError(this.handleError<Lookup[]>('getLookupValues')))
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            this.notificationService.alert("error", "Error while saving", error);
            return of(result as T);
        }

    }

}
